import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import TaskSeries from '../../entities/taskSeries';
import Task from '../../entities/task';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteTaskSeries(): boolean {
return true;
}
export function collectTaskSeriesDeleteImpact(taskSeries: TaskSeries, context: DeleteImpactContext): void {
const key = 'taskSeries:' + taskSeries.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const taskSeriesPreviousSeriesIdImpact = workingRows<TaskSeries>('taskSeries', findAll<TaskSeries>('taskSerieses')).filter(taskSeriesRef => taskSeriesRef.previousSeriesId === taskSeries.id);
taskSeriesPreviousSeriesIdImpact.forEach(taskSeriesRef => addDeleteImpact(context, 'taskSeries:' + taskSeriesRef.id, 'taskSerieses'));}
export function deleteImpactTaskSeries(taskSeries: TaskSeries): DeleteImpact {
const context = deleteImpactContext();
collectTaskSeriesDeleteImpact(taskSeries, context);
return deleteImpactCounts(context);
}
export function deleteTaskSeries(taskSeries: TaskSeries, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteTaskSeries()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectTaskSeriesDeleteImpact(taskSeries, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || taskSeries.id};
}
const key = 'taskSeries:' + taskSeries.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<TaskSeries>('taskSeries', [...store.getState().taskSerieses.getMappingFor('previousSeriesId', taskSeries.id)]).filter(taskSeriesTemp => taskSeriesTemp.previousSeriesId === taskSeries.id).forEach(taskSeriesTemp => {
const _taskSeries = ((_work.get('taskSeries:' + taskSeriesTemp.id) ?? taskSeriesTemp) as TaskSeries).clone();
if (_taskSeries.status === 'D') return;
_taskSeries.status = 'U';
_taskSeries.addedOn = newHRTimestamp();
_taskSeries.addedBy = getCurrentUserId();
_taskSeries.importSource = targetImportSource;
_taskSeries.importId = mergeId;
if (_taskSeries.previousSeriesId === taskSeries.id) {
_taskSeries.previousSeriesId = null;

}
_work.set('taskSeries:' + _taskSeries.id, _taskSeries);
dispatch(Actions.TaskSeriesActions.saveTaskSeriesQueue(_taskSeries), 'taskSeries:' + _taskSeries.id);
});
const deleted = taskSeries.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.TaskSeriesActions.removeTaskSeriesQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceTaskSeries(taskSeries: TaskSeries, replaceWith: TaskSeries, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = taskSeries.id;}
const _work = workingSet();
workingRows<Task>('task', [...store.getState().tasks.getMappingFor('seriesId', taskSeries.id)]).filter(taskTemp => taskTemp.seriesId === taskSeries.id).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
if (_task.status === 'D') return;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.seriesId === taskSeries.id) {
_task.seriesId = replaceWith.id;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
workingRows<TaskSeries>('taskSeries', [...store.getState().taskSerieses.getMappingFor('previousSeriesId', taskSeries.id)]).filter(taskSeriesTemp => taskSeriesTemp.previousSeriesId === taskSeries.id).forEach(taskSeriesTemp => {
const _taskSeries = ((_work.get('taskSeries:' + taskSeriesTemp.id) ?? taskSeriesTemp) as TaskSeries).clone();
if (_taskSeries.status === 'D') return;
_taskSeries.status = 'U';
_taskSeries.addedOn = newHRTimestamp();
_taskSeries.addedBy = getCurrentUserId();
_taskSeries.importSource = targetImportSource;
_taskSeries.importId = mergeId;
if (_taskSeries.previousSeriesId === taskSeries.id) {
_taskSeries.previousSeriesId = replaceWith.id;

}
_work.set('taskSeries:' + _taskSeries.id, _taskSeries);
store.dispatch(Actions.TaskSeriesActions.saveTaskSeriesQueue(_taskSeries));
});



return taskSeries;
}
